import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { Employee } from 'src/app/feature-module/employees/models/Employee';


@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]]
    }]
})
export class EmployeeFormComponent implements OnInit {

  @Input() form: UntypedFormGroup;

  editMode: boolean;
  employee: Employee;

  ngOnInit(): void {

    this.employee = this.form.value;
    this.editMode = this.employee.id > 0;
  }

  avatarSet(event:string){
    this.form.controls.avatar.setValue(event);
  }
}